// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
class Region extends Marionette.Region {}

export default Region
